import {FC, useCallback, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {Field, ErrorMessage, useField} from 'formik'
import {useDropzone} from 'react-dropzone'
import {AnimaBaixo, AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import {RelatedFilesWrapper} from '../../../Link/components/relatedFiles-list/relatedFilesList'

const Step3: FC = () => {
  const intl = useIntl()
  const [fieldPath, , helpersPath] = useField('path')
  // const [checked, setChecked] = useState(true)
  let arquivo: any = []

  const onDrop = useCallback((acceptedFiles: any) => {
    console.log('acceptedFiles', acceptedFiles)
    //helpers3.setValue(acceptedFiles)
    if (acceptedFiles.length > 1) {
      arquivo.forEach((element: any) => {
        acceptedFiles.push(element)
      })
    } else {
      if (arquivo.length > 0) {
        arquivo.forEach((element: any) => {
          acceptedFiles.push(element)
        })
        arquivo.push(acceptedFiles[0])
      } else {
        arquivo.push(acceptedFiles[0])
      }
    }
    //setActive(true)
    // eslint-disable-next-line
    helpersPath.setValue(arquivo)
  }, [])

  const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})

  useEffect(() => {
    if (fieldPath.value) {
      fieldPath.value.forEach((element: any) => {
        arquivo.push(element)
      })

      setFilesZero(
        arquivo.map((file: any) => (
          <AnimaBaixo>
            <p className='text-primary mt-10 dropzone'>
              <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />{' '}
              {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
            </p>
          </AnimaBaixo>
        ))
      )

      console.log('arquivo', arquivo)
    }
    // eslint-disable-next-line
  }, [])

  const files = acceptedFiles.map((file: any) => (
    <AnimaBaixo>
      <p className='text-primary mt-10 dropzone'>
        <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />{' '}
        {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
      </p>
    </AnimaBaixo>
  ))

  const [filesZero, setFilesZero] = useState<any>([])

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-4'>
          <h2 className='fw-bolder d-flex align-items-center text-dark'>
            {intl.formatMessage({id: 'CONDITIONINGS.STEP3'})}
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title={intl.formatMessage({id: 'CONDITIONINGS.STEP3LEG'})}
            ></i>
          </h2>

          <div className='text-gray-400 fw-bold '>
            {intl.formatMessage({id: 'CONDITIONINGS.STEP3SUB'})}
          </div>
        </div>

        <div className='fv-row'>
          <div className='col-lg-12 mt-3'>
            {/* inicio teste dropzone */}
            <div className='col-lg-12 mt-4'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.PROOF'})}
              </label>
              <div className='dropzone  my-1' {...getRootProps()}>
                <div className='dz-message needsclick'>
                  <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                  <div className='ms-4'>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                        {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                      </h3>
                    ) : (
                      <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                        {intl.formatMessage({id: 'DROPZONE.TITLE'})}
                      </h3>
                    )}

                    <label
                      htmlFor='license_documentation'
                      className='fs-7 fw-semibold text-gray-400'
                    >
                      {intl.formatMessage({id: 'DROPZONE.SUBTITLE'})}
                    </label>
                  </div>
                </div>
                <p>{files?.length > 0 ? files : filesZero}</p>
              </div>
            </div>
          </div>
          {/* fim teste dropzone */}
          {/* inicio Observação */}
          <div className='col-lg-12'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
            </label>
            <div className='d-flex position-relative my-1'>
              <Field
                as='textarea'
                name='observation'
                className='form-control form-control-lg form-control-solid'
                placeholder={intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
                rows={3}
              />
              <div className='text-danger mt-2'>
                <ErrorMessage name='observation' />
              </div>
            </div>
          </div>
          {/* fim Observação */}

          {/* Inicio Tabela */}
          <RelatedFilesWrapper />
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step3}
